<div style="width: 100%" [style.height.px]="sidebarService.isBelowMobileWidth() ? 300 : 380">
    @if (lineChartReady && !showLoadingIndicator) {
        <div style="width: 100%; height: 100%; position: relative">
            <app-chart-host chartType="line">
                <canvas #myChart baseChart id="chart" [height]="sidebarService.isBelowMobileWidth() ? 300 : 380" class="lineChart" [data]="lineChartData" [options]="lineChartOptions" [legend]="lineChartLegend" [type]="lineChartType">
                </canvas>
            </app-chart-host>
        </div>
    } @else {
        <div style="display: flex; justify-content: center; align-items: center; height: 100%">
            <app-loading-indicator [size]="'large'" [color]="'secondary'"></app-loading-indicator>
        </div>
    }
</div>
